import libPhoneNumber from 'google-libphonenumber';

export const E164 = libPhoneNumber.PhoneNumberFormat.E164;

export const phoneUtil = libPhoneNumber.PhoneNumberUtil.getInstance();